import React from 'react';

const SalesPopupForm = ({ formData, errors, handleChange }) => {
  return (
    <div className="sales-popup-form__form">
      <div className="form-group">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Name*"
          className={errors.name ? 'error' : ''}
        />
        <div className="error-message-container">
          <p className="error-message">{errors.name}</p>
        </div>
      </div>

      <div className="form-group">
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Phone Number*"
          className={errors.phone ? 'error' : ''}
        />
        <div className="error-message-container">
          <p className="error-message">{errors.phone}</p>
        </div>
      </div>
    </div>
  );
};

export default SalesPopupForm;




